import Switch from 'react-switch';
import React from 'react';

const Toggle = ({ label, textOff = 'Выкл', textOn = 'Вкл', onChange, value }) => {
  return (
    <>
      {label && <label className="block text-gray-700 text-sm ml-2 mb-2">{label}</label>}
      <Switch
        onChange={onChange}
        checked={value}
        onColor="#f97316"
        offColor="#d1d5db"
        handleDiameter={28}
        height={36}
        width={80}
        borderRadius={20}
        uncheckedIcon={<div className="flex items-center justify-start h-full pl-2 pr-1 text-white text-sm font-medium">{textOff}</div>}
        checkedIcon={<div className="flex items-center justify-end h-full pr-2 pl-1 text-white text-sm font-medium">{textOn}</div>}
        className="react-switch"
      />
    </>
  );
};
export default Toggle;
